import React, { FC } from 'react';
import { useI18n } from '~Hooks';
import HandyPageWrapper from '~Scenes/Handy/Components/HandyPageWrapper';
import { usePage } from '~Scenes/Handy/Context/PageProvider';
import HistoryOrdersList from '~Scenes/History-v2/Components/HistoryOrdersList';

const HandyHistory: FC = () => {
  const page = usePage();
  const { i18n } = useI18n();

  return (
    <HandyPageWrapper pageTitle={i18n('Handy.Page.history')}>
      <HistoryOrdersList
        onChequeClick={(chequeId) => page.navigateTo('history-ongoing-cheque', chequeId)}
        onOrderClick={(orderId) => {
          page.navigateTo('history-order', orderId);
        }}
      />
    </HandyPageWrapper>
  );
};

export default HandyHistory;
